import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useTranslation} from "react-i18next";
import {useContext, useEffect, useState} from "react";
import Tab from "react-bootstrap/Tab";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import Nav from "react-bootstrap/Nav";

import {SwalAlertClass} from "core/swalClass";
import TabData from "./TabData";

import {formDataToJson} from "core/utils/formularies";
import {publishEvent} from "core/eventsConnector";
import axiApi from "ApiCaller";
import validateTabbedForm from "views/utils/validateTabbedForm";
import FormButton from "components/buttons/FormButton";
import ConditionalRender from "components/ConditionalRender";

const FormRouteFly = ({show, setShow, item, setItem, params}) => {
    const {t: _Tf} = useTranslation("forms");
    const [activeKey, setActiveKey] = useState("data");
    const [isSubmit, setIsSubmit] = useState(false);
    const Alert = new SwalAlertClass({confirmButtonText: _Tf("labels.accept")});

    useEffect(() => {}, [item]);

    const handleClose = () => {
        setShow(false);
    };

    const onSubmit = (e) => {
        e.preventDefault();
        setIsSubmit(true);

        const form = new FormData(e.target);
        const formValidations = validateTabbedForm(e.target);
        if (!formValidations.isValid) {
            Alert.warning(_Tf("labels.incomplete"), formValidations.errors.join("\n"));
            setIsSubmit(false);
            return false;
        }
        const dataSend = formDataToJson(form);
        axiApi
            .post("/api/distribution/routes/fly-tipping/", dataSend)
            .then((resp) => {
                if (resp.status === 200) {
                    Alert.info("Guardado", "Se ha guardado correctamente");
                    setShow(false);
                    publishEvent("view:route-fly:apply-filters", {});
                }
            })
            .finally(() => {
                setIsSubmit(false);
            });
    };

    const createInstance = async () => {
        try {
            const resp = await axiApi.put("/api/distribution/routes/fly-tipping/", {id: item.id});
            if (resp.status === 201) {
                setShow(false);
                Alert.info("Guardado", "Se ha guardado correctamente");
                publishEvent("view:route-mooch:apply-filters", {});
            }
        } catch (error) {
            const msg = error.response?.data?.message || "Error al crear la instancia";
            Alert.error("Error", msg);
        }
    };

    return (
        <Offcanvas
            show={show}
            onHide={handleClose}
            placement="end"
            backdrop="static"
            aria-modal="true"
            style={{width: "688px", fontSize: "15px"}}
            tabIndex={show ? 0 : -1}>
            <Offcanvas.Header className="preview-canvas">
                <div className="preview-icon">
                    <FontAwesomeIcon icon="sack-xmark" />
                </div>
                <div className="preview-title">
                    <Offcanvas.Title>
                        {_Tf("labels.route")} {_Tf("labels.mooch")}
                    </Offcanvas.Title>
                </div>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <form className="row g-3" onSubmit={onSubmit}>
                    <input type="hidden" name="id" value={item.id} />

                    <Tab.Container activeKey={activeKey} onSelect={(k) => k !== "create" && setActiveKey(k)}>
                        <Nav variant="tabs">
                            <Nav.Item>
                                <Nav.Link eventKey="data">{_Tf("common.data")}</Nav.Link>
                            </Nav.Item>

                            <Nav.Item>
                                <Nav.Link eventKey="programming">Programaciones</Nav.Link>
                            </Nav.Item>
                            <ConditionalRender condition={item.id}>
                                <Nav.Item className="ms-auto">
                                    <Button variant="primary" className="me-2" onClick={createInstance}>
                                        Instanciar
                                    </Button>
                                </Nav.Item>
                            </ConditionalRender>
                        </Nav>

                        <Tab.Content>
                            <Tab.Pane eventKey="data">
                                <TabData item={item} params={params} _Tf={_Tf} />
                            </Tab.Pane>

                            <Tab.Pane eventKey="programming">List programmings</Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                    <div className="buttons-footer buttons-footer pb-3 pe-5">
                        <div className="mt-5 d-flex justify-content-end align-center">
                            <button type="button" className="btn btn-secondary me-3" onClick={handleClose}>
                                {_Tf("labels.cancel")}
                            </button>
                            <FormButton type="submit" className="btn btn-primary" isProcessing={isSubmit}>
                                {_Tf("labels.save")}
                            </FormButton>
                        </div>
                    </div>
                </form>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default FormRouteFly;
